import { render, staticRenderFns } from "./CountriesAdd.vue?vue&type=template&id=765d7d06"
import script from "./CountriesAdd.vue?vue&type=script&lang=js"
export * from "./CountriesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports